import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=57fcc32e&scoped=true&"
import script from "./Fail.vue?vue&type=script&lang=js&"
export * from "./Fail.vue?vue&type=script&lang=js&"
import style0 from "./Fail.vue?vue&type=style&index=0&id=57fcc32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fcc32e",
  null
  
)

export default component.exports